import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'white-label-footer-calauctions',
    imports: [],
    templateUrl: './white-label-footer-calauctions.component.html',
    styleUrls: ['./white-label-footer-calauctions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhiteLabelFooterCalAuctionsComponent {
  public currentYear = new Date().getFullYear();
}
